import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import AppIcon from '../../../../../components/AppIcon';

const PopularApps = ({ apps, title, appSize = 48, disabled = false, className, onAppSelect }) => (
  <div className={cx('popular-apps', { disabled }, className)}>
    {title && <p className="popular-apps__title">{title}</p>}

    <div className="popular-apps__list">
      {apps.map((app) => (
        <div
          key={app.ref_no}
          onClick={() => !disabled && onAppSelect([app])}
          className={cx('popular-apps__list-item', { disabled })}
        >
          <AppIcon
            url={app.big_icon_url || app.icon_url}
            store={app.store}
            size={appSize}
            alt={app.name}
            hideHtmlTitle
            withBorder
          />
        </div>
      ))}
    </div>
  </div>
);

PopularApps.propTypes = {
  apps: T.array.isRequired,
  title: T.string,
  appSize: T.number,
  disabled: T.bool,
  className: T.string,
  onAppSelect: T.func.isRequired,
};

export default PopularApps;
